import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useRef, useState } from 'react';
import { PUBLISHED } from './constants';
import css from './UGC.module.scss';
import handleToArray from '../../utils/social/handleToArray';
import Handles from './Handles';
import outerWidth from '../../utils/dom/outerWidth';
import Products from './Products';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var UGC = function UGC(_ref) {
  var enabled = _ref.enabled,
      image = _ref.image,
      instagramProducts = _ref.instagramProducts,
      userHandle = _ref.userHandle,
      fixed = _ref.fixed;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      on = _useState2[0],
      setOn = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var rootRef = useRef(null);
  var handles = userHandle ? handleToArray(userHandle) : false;
  var alt = userHandle ? "Instagram account".concat(handles.length > 1 ? 's' : '', " ").concat(handles.join(', ')) : image.alt;
  var products = instagramProducts.edges.filter(function (_ref2) {
    var product = _ref2.node.product;
    return product.status === PUBLISHED;
  });
  useEffect(function () {
    setWidth(outerWidth(rootRef.current));
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.on, on)]),
    ref: rootRef,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      alt: alt,
      sizes: [320, 500, 1000, 1200, 1500, 1800, 2400],
      wrap: false
    })), userHandle && /*#__PURE__*/_jsx(Handles, {
      handles: handles,
      total: products.length
    }), width > 0 && products.length > 0 && /*#__PURE__*/_jsx(Products, {
      enabled: enabled,
      fixed: fixed,
      on: on,
      products: products,
      setOn: setOn,
      width: width
    })]
  });
};

UGC.defaultProps = {
  enabled: true,
  fixed: false,
  userHandle: false
};
UGC.propTypes = {
  enabled: PropTypes.bool,
  fixed: PropTypes.bool,
  image: PropTypes.shape({
    alt: PropTypes.string
  }).isRequired,
  instagramProducts: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  userHandle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default /*#__PURE__*/memo(UGC);